import type { AssetStatus } from '../api';

const CONFIG: Record<AssetStatus, { label: string; className: string }> = {
  in_use: { label: 'Em uso', className: 'bg-green-100 text-green-800' },
  available: { label: 'Disponível', className: 'bg-blue-100 text-blue-800' },
  in_maintenance: { label: 'Em manutenção', className: 'bg-purple-100 text-purple-800' },
  on_loan: { label: 'Emprestado', className: 'bg-yellow-100 text-yellow-800' },
  retired: { label: 'Baixado', className: 'bg-gray-200 text-gray-700' },
  not_found: { label: 'Não localizado', className: 'bg-red-100 text-red-800' },
};

interface Props {
  status: AssetStatus;
}

export function AtivoStatusBadge({ status }: Props) {
  const cfg = CONFIG[status];
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cfg.className}`}>
      {cfg.label}
    </span>
  );
}

export const STATUS_LABELS = Object.fromEntries(
  (Object.entries(CONFIG) as Array<[AssetStatus, { label: string }]>).map(([k, v]) => [k, v.label]),
) as Record<AssetStatus, string>;
